import type { AccountPolicy as AccountPolicyModel } from '@/adapters/catalogv1.g';

export function extractAccountPolicy(model: AccountPolicyModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    accountRef: model.account_ref ?? '',
    policyRef: model.policy_ref ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogAccountPolicy = ReturnType<typeof extractAccountPolicy>;
